import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const EventAreasPage = lazy(() => import('./event-areas-page'));

const EventAreas = () => {
  return (
    <LazyRoute>
      <EventAreasPage />
    </LazyRoute>
  );
};

export { EventAreas };
